module.exports = __webpack_public_path__ + "img/image_part_002.dac7bfbb.jpg";